import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Text } from "sprout-ui-primitives";
import { NorthOutlined } from "sprout-ui-icons";
const LabelsDialogEmpty = ()=>{
    return /*#__PURE__*/ _jsxs(Flex, {
        alignItems: "center",
        justifyContent: "center",
        mt: 4,
        mb: 5,
        children: [
            /*#__PURE__*/ _jsx(NorthOutlined, {}),
            /*#__PURE__*/ _jsx(Text, {
                fontSize: "15px",
                fontWeight: "medium",
                color: "white.100",
                ml: 0,
                children: "Create your first label"
            })
        ]
    });
};
export default LabelsDialogEmpty;
